import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { SeoService } from '../../seo.services';

@Component({
  selector: 'app-aviso-farmacovigilancia',
  templateUrl: './aviso-farmacovigilancia.component.html',
  styleUrls: []
})
export class AvisoFarmacovigilanciaComponent implements OnInit {

  constructor(private title: Title, private seo: SeoService) { }

  ngOnInit() {
  	let t:string ="Aviso de farmacovigilancia | Sinuberase";
  	this.title.setTitle(t);

  	this.seo.generateTags({
  		title:"Aviso de farmacovigilancia | Sinuberase",
  		description: "¿Necesitas reportar un efecto indeseable con un medicamento? Comunícate al 01 800 123 4141 o al 55 5484 4965. También puedes escribirnos a chcpvmexico@sanofi.com",
  		slug: "Aviso-de-farmacovigilancia"
  	})

  	this.seo.closeMenu();
  }

}
